import { render, staticRenderFns } from "./FbExternalLink.vue?vue&type=template&id=b896fb60"
import script from "./FbExternalLink.vue?vue&type=script&lang=js"
export * from "./FbExternalLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports